import { ReactNode } from 'react'
import { Head, usePage } from '@inertiajs/react'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

interface User {
  id: string
  username: string
  admin: boolean
}

interface PageProps {
  currentUser?: User | null
  flash?: {
    notice?: string
    alert?: string
  }
  [key: string]: unknown
}

interface LayoutProps {
  children: ReactNode
  title?: string
  showHeader?: boolean
  showFooter?: boolean
}

export default function Layout({
  children,
  title,
  showHeader = true,
  showFooter = true,
}: LayoutProps) {
  const { currentUser, flash } = usePage<PageProps>().props

  return (
    <>
      <Head>
        <title>{title ? `${title} - three.pm` : 'three.pm'}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <div className="min-h-screen flex flex-col">
        {showHeader && <Header currentUser={currentUser ?? null} />}
        <main className="flex-1">
          {flash?.notice && (
            <div className="bg-green-50 border-b border-green-200 px-4 py-3 text-center text-green-700">
              {flash.notice}
            </div>
          )}
          {flash?.alert && (
            <div className="bg-red-50 border-b border-red-200 px-4 py-3 text-center text-red-700">
              {flash.alert}
            </div>
          )}
          {children}
        </main>
        {showFooter && <Footer />}
      </div>
    </>
  )
}
